// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"menu_wrapper__3QhxI","scrollable":"menu_scrollable__ng2fl","figure":"menu_figure__2Pz3u","ingredientContainer":"menu_ingredientContainer__1TU90"};